import Link from "next/link"
import type { ReactNode } from "react"

interface CTAProps {
  href: string
  title: string
}

export type HeroProps = {
  title: string
  lead?: string
  cta?: CTAProps
  children?: ReactNode
  className?: string
}

const LeadText = ({ children }: { children: ReactNode }) => (
  <p className="text-fg-secondary text-base lg:text-lg">{children}</p>
)

export const Hero = ({ title, lead, cta, className, children }: HeroProps) => {
  return (
    <div
      className={`text-center md:text-left flex flex-col items-center md:items-start gap-1 md:gap-2 pt-8 mb-8 max-w-full ${className || ""}`}
    >
      <h1 className="text-2xl lg:text-4xl font-medium whitespace-pre-line tracking-tight text-balance">
        {title}
      </h1>
      {lead && <LeadText>{lead}</LeadText>}
      {cta && (
        <Link
          href={cta.href}
          className="inline-block px-4 py-2 bg-neutral-50 text-neutral-900 rounded-sm hover:bg-neutral-100"
        >
          {cta.title}
        </Link>
      )}
      {children}
    </div>
  )
}

Hero.displayName = "Hero"
